const steps = [
  {
    title: 'Choose your flavour',
    text: 'Pick from classic Vanilla to our crowd favourites, Rasmalai and Gulab Jamun.',
  },
  {
    title: 'Share your vision',
    text: 'Add photos of the cake you have in mind. Colours, theme, style.',
  },
  {
    title: 'We perfect it together',
    text: 'We finish every detail with you on WhatsApp until it is exactly right.',
  },
]

function JourneySection() {
  return (
    <section className="bg-peach-100">
      <div className="container mx-auto px-4 py-8 md:py-16 max-w-6xl">
        <h2 className="text-[26px] md:text-4xl mb-5 md:mb-10 md:text-center">How it works</h2>
        <ol className="flex flex-col gap-5 md:grid md:grid-cols-3 md:gap-8">
          {steps.map((s, i) => (
            <li key={s.title} className="flex gap-3.5 items-start">
              <span className="w-8 h-8 rounded-full bg-coral-500 text-white font-bold text-sm flex items-center justify-center shrink-0">
                {i + 1}
              </span>
              <div>
                <h3 className="font-sans text-base md:text-lg font-semibold text-charcoal">{s.title}</h3>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed mt-0.5">{s.text}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}

export default JourneySection
